import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';
import MediaTypography from 'components/MediaTypography';
import { DateTime } from 'luxon';
import stripHtmlTags from 'modules/News/utils/stripHtmlTags';
import store from 'store';

import { INewsItemModel } from '@common/models/News/NewsItem';

import {
	NewsItemDate,
	NewsItemImage,
	NewsItemLink,
	NewsItemTitle,
	NewsItemWrap,
	StyledNewsItemNewBadge,
} from './style';

interface PropsType {
	newsItem: INewsItemModel;
}

function NewsItem({ newsItem }: PropsType) {
	const isVisited = store.visitedNews.get(newsItem.id);

	const clearDescription = newsItem.description ? stripHtmlTags(newsItem.description) : '';

	const { t } = useTranslation();

	const formattedDate = DateTime.fromSQL(newsItem.published_at).toLocaleString({
		month: 'long',
		day: 'numeric',
		year: 'numeric',
	});

	return (
		<NewsItemWrap>
			{!isVisited && (
				<StyledNewsItemNewBadge>
					<Typography variant="subtitle1">{t('resources.new')}</Typography>
				</StyledNewsItemNewBadge>
			)}
			<NewsItemLink href={`/news/${newsItem.id}`}>
				<NewsItemImage src={newsItem.image_url} alt="News image" />
				<NewsItemDate>{formattedDate}</NewsItemDate>
				<NewsItemTitle variant="h4" lineClamp={{ default: 1 }} textColor="black">
					{newsItem.title}
				</NewsItemTitle>
				<MediaTypography variant="body2" textColor="helper" lineClamp={{ default: 3 }}>
					{clearDescription}
				</MediaTypography>
			</NewsItemLink>
		</NewsItemWrap>
	);
}

export default observer(NewsItem);
